import React from "react";
import LegalPage from "./LegalPage";

export default function Accessibility() {
  return (
    <LegalPage
      kicker="Accessibility"
      title="Built for everyone."
      updated="February 2026"
      testId="accessibility-page"
    >
      <p>
        LocalizeHER believes that local businesses lifting local women should be accessible to{" "}
        <em>every</em> woman. We design and build with that intent.
      </p>

      <h2>Our commitment</h2>
      <p>
        We aim to conform to the{" "}
        <a
          href="https://www.w3.org/TR/WCAG21/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Web Content Accessibility Guidelines (WCAG) 2.1 Level AA
        </a>{" "}
        across all pages of localizeher.com and the LocalizeHER member platform. Accessibility is
        an ongoing practice for us, not a checkbox.
      </p>

      <h2>What we've done</h2>
      <ul>
        <li>Semantic HTML structure with proper headings, landmarks, and lists.</li>
        <li>
          Color contrast on body text, headings, and primary actions tested against WCAG AA.
        </li>
        <li>Visible focus rings on every interactive element for keyboard navigation.</li>
        <li>"Skip to content" link at the top of every page.</li>
        <li>Descriptive alt text on meaningful imagery; decorative images are hidden from screen readers.</li>
        <li>Form fields are programmatically labelled and announce validation errors.</li>
        <li>No content relies on color alone to convey meaning.</li>
        <li>Animations respect the user's <code>prefers-reduced-motion</code> setting.</li>
        <li>Responsive layouts that work at 200% zoom and on small mobile screens.</li>
      </ul>

      <h2>Where we know we're still improving</h2>
      <ul>
        <li>Auditing all third-party embeds for accessibility.</li>
        <li>Adding closed captions to any video content we publish.</li>
        <li>Expanding our automated and manual accessibility testing as the platform grows.</li>
      </ul>

      <h2>Need help, or found an issue?</h2>
      <p>
        If something on the platform isn't working for you, please tell us. We treat accessibility
        bug reports as priority items.
      </p>
      <p>
        Email <a href="mailto:hello@localizeher.com">hello@localizeher.com</a> with the URL, what
        you were trying to do, and any assistive technology you use. We'll respond within 5
        business days.
      </p>

      <h2>Alternate formats</h2>
      <p>
        Any content published on LocalizeHER is available in an alternate format on request — large
        text, plain text, a phone walkthrough — at no charge. Just ask.
      </p>
    </LegalPage>
  );
}
